export default __webpack_public_path__ + "assets/images/1947fb385c6defb130c01ba459a7ac45.png";